import _ from "lodash";

export default class RecipientHelper {
  constructor(conversation) {
    this.conversation = conversation;

    this.recipients = [];

    this.build();
  }

  getRecipients() {
    return this.recipients;
  }

  getRecipientId(recipient) {
    return _.get(recipient, "contact.id") || _.get(recipient, "visitor.id");
  }

  isReshareTarget(contactId) {
    const reshares = _.get(this.conversation, "item.reshares") || [];
    return reshares.some((reshare) =>
      _.some(reshare.to || [], (to) => to.id === contactId),
    );
  }

  collectRecipientsInTree(nodes, items = []) {
    nodes.forEach((node) => {
      items.push(node.item);
      if (node.children?.length) {
        this.collectRecipientsInTree(node.children, items);
      }
    });
    return items;
  }

  build() {
    const recipients = _.get(this.conversation, "recipients.items") || [];

    this.recipients = recipients
      .filter((recipient) => {
        if (recipient.contact) {
          return !this.isReshareTarget(recipient.contact.id);
        }
        return true;
      })
      .map((recipient) => {
        return {
          item: recipient,
          children: [],
        };
      });

    if (this.recipients.length == 0) {
      this.recipients = recipients.map((recipient) => {
        return {
          item: recipient,
          children: [],
        };
      });
    }

    this.recipients.forEach((recipient) => {
      this.buildTreeForRecipient(recipient, []);
    });

    this.appendOrphanRecipients(recipients);
  }

  appendOrphanRecipients(allRecipients) {
    const placed = this.collectRecipientsInTree(this.recipients);
    const placedIds = new Set(
      placed.map((recipient) => this.getRecipientId(recipient)).filter(Boolean),
    );

    allRecipients.forEach((recipient) => {
      const id = this.getRecipientId(recipient);
      if (id && !placedIds.has(id)) {
        this.recipients.push({
          item: recipient,
          children: [],
        });
        placedIds.add(id);
      }
    });
  }

  buildTreeForRecipient(node, path) {
    const reshares = _.get(this.conversation, "item.reshares") || [];
    const reshare = reshares.find((reshare) => {
      const fromId = _.get(reshare, "from.id");
      if (!fromId) {
        return false;
      }
      if (node.item.contact) {
        return node.item.contact.id === fromId;
      }
      if (node.item.visitor) {
        return node.item.visitor.id === fromId;
      }
      return false;
    });

    if (!reshare) {
      return;
    }

    const recipients = _.get(this.conversation, "recipients.items") || [];
    var children = recipients
      .filter((recipient) => {
        const recipientId = this.getRecipientId(recipient);
        if (!recipientId) {
          return false;
        }
        return _.find(reshare.to || [], { id: recipientId }) != null;
      })
      .filter((recipient) => {
        const recipientId = this.getRecipientId(recipient);
        return recipientId && !this.isRecursivePath(path, recipientId);
      })
      .map((recipient) => {
        return {
          item: recipient,
          children: [],
        };
      });

    node.children = children;

    node.children.forEach((child) => {
      const childPath = [...path, this.getRecipientId(child.item)];
      this.buildTreeForRecipient(child, childPath);
    });
  }

  isRecursivePath(path, id) {
    return path.includes(id);
  }
}
